// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"P7xxZaMP"};